<template>
  <div class="input-rangefield">
    <label :for="inputId">{{ label }}</label>
    <div class="input-rangefield__wrapper">
      <input
        type="range"
        :id="inputId"
        :value="value"
        @input="updateModel($event.target.value)"
        :min="minamount"
        :max="maxamount"
      />
      <p>{{value}} %</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Required props
    value: {
      // value for v-model to bind to
      type: String,
      required: true,
      default: "100"
    },

    // Optional props
    label: String, // label text
    inputId: String, // id to input and label, cause id on component applies it to div
    minamount: [Number, String], // min amount of the value
    maxamount: [Number, String], // max amount of the value
  },
  methods: {
    updateModel(value) {
      // Imitate what v-model does and emit that to parent component v-model
      this.$emit("input", value);
    },
  },
};
</script>

<style scoped></style>
